











import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'

interface Props {
  columnValue: string
  columnName: string
  directory: string
}

export default mixins(WindowResizeListener).extend<{}, {}, {}, Props>({
  props: {
    columnValue: {
      required: true,
    },
    columnName: {
      required: true
    },
    directory: {
      required: true
    }
  },
})
